// @flow
import React, { Component } from 'react'
import { Tooltip } from '../MainTable'
import styled from 'styled-components'
import { alertColor, linkColor, offColor } from '../controls/colors'

const State = styled.div`
  display: inline;
  font-family: 'PT Sans Caption', sans-serif;
  font-weight: bold;
  color: ${({ styleCode }: Object) =>
    styleCode === 'alert' ? alertColor : styleCode === 'off' ? 'gray' : linkColor};
  font-size: 11px;
  line-height: 12px;
  cursor: default;
  &:hover {
    opacity: 0.8;
  }

  ${({ styleCode }: Object) => {
    if (styleCode === 'alert') return `border-bottom: 1px dashed ${alertColor};`
    if (styleCode === 'muted') return `border-bottom: 1px dashed gray;`
    if (styleCode === 'off') return `border-color: ${offColor};`
    return ''
  }}
`

type Props = {|
  triggerText: string,
  hintText: string,
  styleCode?: 'alert' | 'muted' | 'off'
|}

export default class StateHumanHint extends Component<Props> {
  render() {
    const { styleCode, triggerText, hintText } = this.props

    return (
      <Tooltip content={hintText}>
        <State styleCode={styleCode} className="state-human__link">
          {triggerText}
        </State>
      </Tooltip>
    )
  }
}
